const BA_TZ = "America/Argentina/Buenos_Aires";

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "-";
  try {
    return new Intl.DateTimeFormat("es-AR", {
      timeZone: BA_TZ,
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatMinutes(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined) return "-";
  if (minutes < 60) return `${Math.round(minutes)} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  const days = Math.floor(hours / 24);
  return `${days} d`;
}

export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return "-";
  try {
    return new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", maximumFractionDigits: 0 }).format(value);
  } catch {
    return `$${value}`;
  }
}

const EVENT_LABELS: Record<string, string> = {
  lead_created: "Lead capturado",
  stage_move: "Cambio de etapa",
  assignment: "Asignación",
  note: "Nota",
  task_created: "Tarea creada",
  task_completed: "Tarea completada",
};

export function eventLabel(eventType: string): string {
  return EVENT_LABELS[eventType] || eventType;
}
